import { apiClient } from "./api_base";


export const login = async(credentials) => {
    try {
        console.log('Attempting login with credentials:', credentials);
        const response = await apiClient.post('/affiliates/login', credentials);
        console.log('Login successful:', response.data);
        return response;
    } catch (error) {
        console.error('Login failed:', {
            message: error.message,
            code: error.code,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            isNetworkError: error.code === 'ERR_NETWORK',
            isAxiosError: error.isAxiosError
        });
        
        // Provide more specific error messages
        if (error.code === 'ERR_NETWORK') {
            throw new Error('Network error: Unable to connect to the server. Please check your internet connection and try again.');
        } else if (error.response?.status === 404) {
            throw new Error('Invalid credentials: Please check your username and password.');
        } else if (error.response?.status >= 500) {
            throw new Error('Server error: Please try again later.');
        } else {
            throw error;
        }
    }
}

export const logoutAuth = async() => {
    await apiClient.get('/affiliates/logout');
    return true;
}

export const createAffiliate = async (payload) => {
    const response = await apiClient.post('/affiliates/create', {
        inputData: payload
    });
    return response;
}

export const getAffiliateStatus = async () => {
    const response = await apiClient.get('/affiliates/status');
    return response;
};

export const updateAffiliateImage = async (imageUrl) => {
    const response = await apiClient.post('/affiliates/update-image', {
        image: imageUrl
    });
    return response;
};


